import request from '@/utils/request';
import Resource from '@/api/resource';
class TemplateResource extends Resource {
  constructor() {
    super('template');
  }

  // 获取模板列表
  getTemplateListApi(data){
    return request({
      url: 'tool/template',
      method: 'get',
      params: data,
    });
  }

  // 更新模板接口
  updateTemplateApi(id, data) {
    return request({
      url: `tool/template/${id}/update`,
      method: 'post',
      params: data,
    });
  }

  // 删除模板
  deleteTemplateApi(id){
    return request({
      url: `tool/template/${id}`,
      method: 'delete',
    });
  }

  // 获取模板数据
  getTemplateData(id){
    return request({
      url: `tool/template/${id}`,
      method: 'get',
    });
  }

  // 保存模板数据
  addTemplateData(data){
    return request({
      url: `tool/template`,
      method: 'post',
      data,
    });
  }

  // 修改模板名称
  editTemplateName(id, data){
    return request({
      url: `/tool/template/${id}/editName`,
      method: 'post',
      data,
    });
  }

  // 获取定向包模板接口
  getAudienceTemplateData(data){
    return request({
      url: `/tool/package/gdt/getPackageTemplates`,
      method: 'get',
      params: data,
    });
  }

  // 设置模板星标
  setTemplatePointApi(id){
    return request({
      url: `tool/template/addTop/${id}`,
      method: 'POST',
    });
  }

  // 取消模板星标
  cancelTemplatePointApi(id){
    return request({
      url: `tool/template/cancelTop/${id}`,
      method: 'POST',
    });
  }
}
export { TemplateResource as default };
